
import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import * as XLSX from 'xlsx';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-registration-office-representative-vbriefly',
  templateUrl: './registration-office-representative-vbriefly.component.html',
  styleUrl: './registration-office-representative-vbriefly.component.scss'
})
export class RegistrationOfficeRepresentativeVbrieflyComponent {
  isLoading: boolean = false;
  type;
  start_date = '';
  end_date = '';
  rep_name = '';
  off_rep_name = '';
  issue_cat = '';
  issue_date = '';
  newindetails: boolean = false;
  indetail: boolean = false;
  brfly: boolean = false;
  verybrfly: boolean = false;
  datewise: boolean = false;
  officerep: boolean = false;
  inDetailsRegReport = [];
  inDetailsRegReport101 = [];
  inDetailsRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  inDetailsOffRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  tempdata = [];
  inDetailsRegReportsubTotalData = [];
  today;
  issue_name = '';
  issueDate;
  inDetailsRegReport1: any;
  advtamt: number = 0;
  advtamti: number = 0;
  netadvtamt: number = 0;
  netadvtamti: number = 0;
  gstadvtamt: number = 0;
  totaladvtamt: number = 0;
  totalpendingadvtamt: number = 0;
  totalgst: number = 0;
  today1: string;
  issuenamewithdate: any;
  remaingtotal: number = 0;
  jamatotal: number = 0;
  inDetailsbriflydata: any;
  advtamtb: number = 0;
  netadvtamtb: number = 0;
  jamatotalb: number = 0;
  jamatotalc: number = 0;
  remaingtotalb: number = 0;
  inDetailsoff_repdata: any;
  inDetailsoff_repdatab: any;
  inDetailsRegReportrep: any;
  beforegst_amt: number;
  totalbeforegst_amt: number;
  totaldisc_total: number;
  totalbefore_gst: any;
  inDetailsRegReportbtoff: any[] = [];
  total_pending: any;
  inDetailsRegReportdatewise: any;
  showindetail: boolean = false;
  showindetaildatewise: boolean = false;
  showoffdatewise: boolean = false;
  showdatewisevrybrfly: boolean = false;
  showoffrepvrybrfly: boolean = false;
  showindetailoffrep: boolean = false;
  show: boolean;
  issuedatepp: any;
  udhistha: number;
  total_amount: number;
  gsiValues: any[] = [];
  
  

  // Office Representative Specific Properties
  officeRepData: any = null;
  totalUdhistha: number = 0;
  officeAdvt: number = 0;
  officeTotalAmt: number = 0;
  lastYearToday: number = 0;
  lastYearTotalAdvt: number = 0;
  inDetailsRegReportbtoff101: any[];
  regularTotalAmt: number;
  totalBusiness: number;
  // totalUdhisthaPercent: number = 0;

  constructor(
    private dialogref: MatDialogRef<RegistrationOfficeRepresentativeVbrieflyComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  newissuedatepp: any

  ngOnInit(): void {
    this.type = this.data['type'];
    this.start_date = this.data['startDate'];
    this.end_date = this.data['endDate'];
    this.rep_name = this.data['rep_name'];
    this.off_rep_name = this.data['off_rep_name'];
    this.newissuedatepp = this.data['newissuedatepp']
    this.issuedatepp = this.data['issuedatepp']

    this.issue_cat = this.data['issue_cat'] === undefined ? '' : this.data['issue_cat'];
    this.issue_date = this.data['issueDates'] === undefined ? '' : this.data['issueDates'];

    console.log(this.data);
    this.issueDate = this.issue_date + '';
    this.issue_name = this.issueDate.split(',')[0] == 'all' ? this.issueDate.split(',')[2] : this.issueDate.split(',')[1];
    this.issueDate = this.issueDate.split(',')[0] == 'all' ? this.issueDate.split(',')[1] : this.issueDate.split(',')[0];
    this.issueDate = new Date(`${this.issueDate.split('/')[1]}/${this.issueDate.split('/')[0]}/${this.issueDate.split('/')[2]}`);
    this.today = new Date();
    this.today1 = this.datePipe.transform(this.today, 'dd-MM-yyyy');

    if (this.type === 'In Detail') {
      this.indetail = true;
      if (this.off_rep_name !== '') {
        this.officerep = true;
      }
    } else if (this.type === 'Briefly') {
      this.brfly = true;
    } else if (this.type === 'Very Briefly') {
      this.verybrfly = true;
      if (this.off_rep_name !== '') {
        this.officerep = true;
      }
    } else if (this.type === 'Datewise') {
      this.datewise = true;
      this.verybrfly = true;
    }

    if (this.indetail && this.datewise && !this.officerep) {
      this.inDetailsDatewise();
    } else if (this.datewise && this.verybrfly) {
      this.datewiseVeryBriefly();
    } else if (this.indetail && this.officerep && !this.datewise) {
      this.inDetailsOffRep();
    } else if (this.brfly && this.officerep) {
      // this.inDetails();
    } else if (this.indetail && !this.datewise && !this.officerep) {
      this.inDetails();
    } else if (this.verybrfly && this.officerep) {
      this.offrepVeryBriefly();
    } else {
      this.getReportData()
    }
    this.calculateTotalUdhistha();
  }

  getRegReportData() {
    throw new Error('Method not implemented.');
  }

  // exportexcel(fileName): void {
  //   console.log('Export function called with fileName:', fileName);

  //   let element = document.getElementById('print-section');
  //   console.log('Element found:', element);

  //   if (!element) {
  //     console.error('Element with ID "print-section" not found in DOM');
  //     return;
  //   }

  //   try {
  //     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  //     console.log('Worksheet created:', ws);

  //     const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //     XLSX.writeFile(wb, fileName + '.xlsx');
  //     console.log('File should be downloaded');
  //   } catch (error) {
  //     console.error('Error during export:', error);
  //   }
  // }


  exportexcel(fileName: string): void {
    const mainTable = document.getElementById('print-section');
    const footerTable = document.querySelector('.second-page-table');

    if (!mainTable) {
      console.error('Main table not found!');
      return;
    }

    try {
      // Create workbook
      const wb = XLSX.utils.book_new();

      // Convert main table to worksheet
      const ws = XLSX.utils.table_to_sheet(mainTable);

      // If footer table exists, append it
      if (footerTable) {
        const footerWs = XLSX.utils.table_to_sheet(footerTable);
        const footerData = XLSX.utils.sheet_to_json(footerWs, { header: 1 });

        // Append footer rows below main table
        XLSX.utils.sheet_add_json(ws, footerData, {
          skipHeader: true,
          origin: -1, // append after existing content
        });
      }

      // Add to workbook and export
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Error during export:', error);
    }
  }


  filteredinDetailsRegReport;

  addFilters() {
    if (this.start_date != '' && this.end_date != '' && this.rep_name != '' && this.off_rep_name != '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
      console.log(this.filteredinDetailsRegReport, "kjl");
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name == '' && this.off_rep_name != '' && this.issue_cat != '' && this.issue_date != '') {
      console.log('excluded repname Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name != '' && this.off_rep_name == '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name != '' && this.off_rep_name != '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name'])
        );
      });
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name == '' && this.off_rep_name == '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name == '' && this.off_rep_name != '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.off_rep_name.includes(a['off_rep_name'])
        );
      });
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name != '' && this.off_rep_name == '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name'])
        );
      });
    } else if (this.start_date != '' && this.end_date != '' && this.rep_name == '' && this.off_rep_name == '' && this.issue_cat == '' && this.issue_date == '') {
      console.log('just datewise Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date
        );
      });
      console.log(this.filteredinDetailsRegReport);
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name != '' && this.off_rep_name != '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name == '' && this.off_rep_name != '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name != '' && this.off_rep_name == '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.rep_name.includes(a['rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name != '' && this.off_rep_name != '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name'])
        );
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name == '' && this.off_rep_name == '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name == '' && this.off_rep_name != '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a['off_rep_name']);
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name != '' && this.off_rep_name == '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.rep_name.includes(a['rep_name']);
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name == '' && this.off_rep_name != '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a['off_rep_name']);
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name == '' && this.off_rep_name == '' && this.issue_cat != '' && this.issue_date != '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (this.start_date == '' && this.end_date == '' && this.rep_name == '' && this.off_rep_name == '' && this.issue_cat == '' && this.issue_date == '') {
      this.filteredinDetailsRegReport = this.inDetailsRegReport;
    }
    console.log(this.filteredinDetailsRegReport);
    this.filtersCalculateData();
  }

  filtersCalculateData() {
    this.inDetailsRegReportTotal = {
      total_advt: 0,
      net_amt: 0,
      advt_total: 0,
      gst: 0,
      total_amt: 0,
      rcvd_amt: 0,
      pndg_amt: 0
    };

    this.inDetailsRegReportTotal.total_advt = this.filteredinDetailsRegReport.length;

    for (let index = 0; index < this.filteredinDetailsRegReport.length; index++) {
      const row = this.filteredinDetailsRegReport[index];

      this.inDetailsRegReportTotal.net_amt += parseFloat(row['total_amount'] || 0);
      this.inDetailsRegReportTotal.advt_total += parseFloat(row['advt_amt'] || 0);
      this.inDetailsRegReportTotal.gst += parseFloat(row['sgst'] || 0);
      this.inDetailsRegReportTotal.gst += parseFloat(row['cgst'] || 0);
      this.inDetailsRegReportTotal.total_amt += parseFloat(row['amount'] || 0);
      this.inDetailsRegReportTotal.pndg_amt += parseFloat(row['part_pymt_remaning_amt'] || 0);
    }
  }

  // **NEW METHOD: Separate office rep data from regular reps**
  // separateOfficeRepData(data: any[]) {
  //   this.inDetailsRegReportbtoff = [];
  //   this.inDetailsRegReportbtoff101 = [];

  //   this.officeRepData = null;
  //   this.officeAdvt = 0;
  //   this.officeTotalAmt = 0;

  //   data.forEach(item => {
  //     if (item.off_rep_name === 'कार्यालय - जाहिरात विभाग') {
  //       // Store office rep data separately
  //       this.officeRepData = item;
  //       this.officeAdvt = parseFloat(item.Udishta_8) || 0;

  //       // **Get magil values from the data (should be at root level or in office rep)**
  //     this.magil_varshachi_aajchi_stithi = this.officeRepData?.magil_varshachi_aajchi_stithi || '0';
  //     this.magil_varshyachya_ekun_jahirata = this.officeRepData?.magil_varshyachya_ekun_jahirata || '0';

  //       // Calculate office total amount from rep_data
  //       if (item.rep_data && item.rep_data.length > 0) {
  //         item.rep_data.forEach((rep: any) => {
  //           this.officeTotalAmt += parseFloat(rep.total_amt) || 0;
  //         });
  //       }
  //     } else {
  //       // Add to regular representatives list
  //       this.inDetailsRegReportbtoff.push(item);
  //     }
  //   });

    

  //   this.inDetailsRegReportbtoff101 = data;
  // }


  separateOfficeRepData(data: any[]) {
  // clear previous
  this.inDetailsRegReportbtoff = [];
  this.inDetailsRegReportbtoff101 = [];
  this.officeRepData = null;
  this.officeAdvt = 0;
  this.officeTotalAmt = 0;
  this.regularTotalAmt = 0;
  this.totalBusiness = 0;

  // helper: safely parse numbers (removes commas/currency etc)
  const parseNum = (v: any): number => {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    let s = String(v);
    // remove common non-numeric characters (commas, currency symbols, spaces, percent, etc.)
    s = s.replace(/[,₹\s%]/g, '').replace(/[^\d.-]/g, '');
    return s === '' ? 0 : parseFloat(s) || 0;
  };

  const isOffice = (name: string) => (name || '').toString().trim() === 'कार्यालय - जाहिरात विभाग';
  const isEkun = (name: string) => /एकून/.test((name || '').toString());

  // separate rows
  data.forEach(item => {
    const name = (item.off_rep_name || '').toString().trim();

    if (isOffice(name)) {
      // office row: capture details and compute office total (either aggregated field or nested rep_data)
      this.officeRepData = item;
      this.officeAdvt = parseNum(item.Udishta_8 ?? item.udishta_8 ?? 0);

      if (Array.isArray(item.rep_data) && item.rep_data.length) {
        this.officeTotalAmt = item.rep_data.reduce((s: number, r: any) => s + parseNum(r.total_amt ?? r.total), 0);
      } else {
        this.officeTotalAmt = parseNum(item.total_amt ?? item.total);
      }

      // magil fields may live in the office row (fall back to existing values)
      this.magil_varshachi_aajchi_stithi = item.magil_varshachi_aajchi_stithi ?? this.magil_varshachi_aajchi_stithi ?? '0';
      this.magil_varshyachya_ekun_jahirata = item.magil_varshyachya_ekun_jahirata ?? this.magil_varshyachya_ekun_jahirata ?? '0';

    } else if (isEkun(name)) {
      // skip summary rows completely for per-rep totals
    } else {
      // normal representative — keep for listing and later summing
      this.inDetailsRegReportbtoff.push(item);
    }
  });

  // compute regular reps total (handles nested rep_data or a top-level total_amt)
  this.regularTotalAmt = this.inDetailsRegReportbtoff.reduce((sum: number, item: any) => {
    if (Array.isArray(item.rep_data) && item.rep_data.length) {
      return sum + item.rep_data.reduce((s: number, r: any) => s + parseNum(r.total_amt ?? r.total), 0);
    }
    return sum + parseNum(item.total_amt ?? item.total ?? item['TOTAL AMT']);
  }, 0);

  // final combined total (regular + office)
  this.totalBusiness = this.regularTotalAmt + this.officeTotalAmt;

  // keep full original copy if you need it in the UI
  this.inDetailsRegReportbtoff101 = data;

  // debug: helpful to verify
  console.log('regularTotal', this.regularTotalAmt, 'officeTotal', this.officeTotalAmt, 'combined', this.totalBusiness);
}


  getReportData() {
    const req1: any = {
      "start_date": this.start_date,
      "end_date": this.end_date,
      "rep_name": this.rep_name,
      "off_rep_name": this.off_rep_name,
      "issuename": this.issue_cat,
      "issue_date": this.issue_date
    }

    this.service.getRegReportInDetails1(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsRegReport1 = data;
      this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
      console.log(this.inDetailsRegReport1, "reg report")

      this.advtamti = 0;
      this.netadvtamti = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalc = 0;
      this.totalbeforegst_amt = 0;
      this.totaldisc_total = 0;

      for (let data1 of this.inDetailsRegReport1) {
        this.advtamti += parseFloat(data1.advt_amt) || 0;
        this.netadvtamti += parseFloat(data1.amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotal += parseFloat(data1.remaingamt) || 0;
        this.totalbeforegst_amt += parseFloat(data1.total_amount) || 0;
        this.jamatotalc += parseFloat(data1.pymt_rcv_amt) || 0;
        this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;

        data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
        this.totalgst += parseFloat(data1.totalgst)
      }

      console.log(this.totalbeforegst_amt, "before gst")
      console.log(this.inDetailsRegReport, "indeatils");
      this.addFilters();
      this.getReportDatewise();
    });

    //old  // **UPDATED: Off-Representative Details with Separation Logic**
    // this.service.getRegReportInDetailsoff(req1).subscribe((data) => {
    //   this.inDetailsRegReport = data;

    //   // **CRITICAL: Separate office rep from regular reps**
    //   this.separateOfficeRepData(data);

    //   this.inDetailsRegReport1 = data;
    //   this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
    //    this.magil_varshachi_aajchi_stithi = this.officeRepData?.magil_varshachi_aajchi_stithi || '0';
    //    this.magil_varshyachya_ekun_jahirata = this.officeRepData?.magil_varshyachya_ekun_jahirata || '0';


    //   console.log('Regular Reps:', this.inDetailsRegReportbtoff);
    //   console.log('Office Rep:', this.officeRepData);

    //   // Initialize grand totals
    //   this.advtamt = 0;
    //   this.netadvtamt = 0;
    //   this.gstadvtamt = 0;
    //   this.totaladvtamt = 0;
    //   this.totalgst = 0;
    //   this.remaingtotal = 0;
    //   this.totalpendingadvtamt = 0;
    //   this.jamatotal = 0;
    //   this.totalbeforegst_amt = 0;
    //   this.totaldisc_total = 0;

    //   // Calculate totals for REGULAR off-representatives only (excluding office)
    //   for (let offRepData of this.inDetailsRegReportbtoff) {
    //     // Initialize off-rep totals
    //     offRepData.total_advt_amt = 0;
    //     offRepData.total_net_amt = 0;
    //     offRepData.total_before_gst_amt = 0;
    //     offRepData.total_gst_amt = 0;
    //     offRepData.total_amount = 0;
    //     offRepData.total_receive_amt = 0;
    //     offRepData.total_pending_amt = 0;

    //     // Calculate totals for each representative under this off-rep
    //     for (let repData of offRepData.rep_data) {
    //       offRepData.total_advt_amt += parseFloat(repData.total_advt_amount) || 0;
    //       offRepData.total_net_amt += parseFloat(repData.total_discounted_amt) || 0;
    //       offRepData.total_before_gst_amt += parseFloat(repData.total_before_gst) || 0;
    //       offRepData.total_gst_amt += parseFloat(repData.total_gst) || 0;
    //       offRepData.total_amount += parseFloat(repData.total_amt) || 0;
    //       offRepData.total_receive_amt += parseFloat(repData.pymt_rcv_amt) || 0;
    //       offRepData.total_pending_amt += parseFloat(repData.total_pending) || 0;
    //     }

    //     // Add off-rep totals to grand totals (ONLY regular reps, not office)
    //     this.advtamt += offRepData.total_advt_amt;
    //     this.totaladvtamt += offRepData.total_net_amt;
    //     this.totalbeforegst_amt += offRepData.total_before_gst_amt;
    //     this.totalgst += offRepData.total_gst_amt;
    //     this.netadvtamt += offRepData.total_amount;
    //     this.jamatotal += offRepData.total_receive_amt;
    //   }

    //   console.log('Grand Total (excluding office):', this.netadvtamt);
    //   console.log('Office Total:', this.officeTotalAmt);

    //   this.calculateTotalUdhistha();
    //   this.addFilters();
    //   this.getReportDatewise();
    // });



    // **UPDATED: Off-Representative Details - Including Office Department**



    

    // this.service.getRegReportInDetailsoff(req1).subscribe((data) => {
    //   this.inDetailsRegReport = data;

    //   // **Store all off-reps INCLUDING office department**
    //   this.inDetailsRegReportbtoff = data || [];

    //   this.inDetailsRegReport1 = data;
    //   this.issuenamewithdate = this.inDetailsRegReport1.issue_date;

    //   console.log('All Off-Reps (including office):', this.inDetailsRegReportbtoff);

    //   // Initialize grand totals
    //   this.advtamt = 0;
    //   this.netadvtamt = 0;
    //   this.gstadvtamt = 0;
    //   this.totaladvtamt = 0;
    //   this.totalgst = 0;
    //   this.remaingtotal = 0;
    //   this.totalpendingadvtamt = 0;
    //   this.jamatotal = 0;
    //   this.totalbeforegst_amt = 0;
    //   this.totaldisc_total = 0;

    //   // Calculate totals for ALL off-representatives (including office)
    //   for (let offRepData of this.inDetailsRegReportbtoff) {
    //     // Initialize off-rep totals
    //     offRepData.total_advt_amt = 0;
    //     offRepData.total_net_amt = 0;
    //     offRepData.total_before_gst_amt = 0;
    //     offRepData.total_gst_amt = 0;
    //     offRepData.total_amount = 0;
    //     offRepData.total_receive_amt = 0;
    //     offRepData.total_pending_amt = 0;

    //     // Calculate totals for each representative under this off-rep
    //     if (offRepData.rep_data && offRepData.rep_data.length > 0) {
    //       for (let repData of offRepData.rep_data) {
    //         offRepData.total_advt_amt += parseFloat(repData.total_advt_amount) || 0;
    //         offRepData.total_net_amt += parseFloat(repData.total_discounted_amt) || 0;
    //         offRepData.total_before_gst_amt += parseFloat(repData.total_before_gst) || 0;
    //         offRepData.total_gst_amt += parseFloat(repData.total_gst) || 0;
    //         offRepData.total_amount += parseFloat(repData.total_amt) || 0;
    //         offRepData.total_receive_amt += parseFloat(repData.pymt_rcv_amt) || 0;
    //         offRepData.total_pending_amt += parseFloat(repData.total_pending) || 0;
    //       }
    //     }

    //     // Add off-rep totals to grand totals (ALL reps including office)
    //     this.advtamt += offRepData.total_advt_amt;
    //     this.totaladvtamt += offRepData.total_net_amt;
    //     this.totalbeforegst_amt += offRepData.total_before_gst_amt;
    //     this.totalgst += offRepData.total_gst_amt;
    //     this.netadvtamt += offRepData.total_amount;
    //     this.jamatotal += offRepData.total_receive_amt;
    //     this.totalpendingadvtamt += offRepData.total_pending_amt;
    //   }

    //   console.log('Grand Total (including all reps):', this.netadvtamt);
    //   console.log('Total Received:', this.jamatotal);
    //   console.log('Total Pending:', this.totalpendingadvtamt);

    //   this.calculateTotalUdhistha();
    //   this.addFilters();
    //   this.getReportDatewise();
    //   //  // **CRITICAL: Separate office rep from regular reps**
    //   this.separateOfficeRepData(data);

     

      


    // });


//     this.service.getRegReportInDetailsoff(req1).subscribe((data) => {
//   this.inDetailsRegReport = data;

//   // **Store all off-reps INCLUDING office department**
//   this.inDetailsRegReportbtoff = data || [];

//   this.inDetailsRegReport1 = data;
//   this.issuenamewithdate = this.inDetailsRegReport1.issue_date;

//   console.log('All Off-Reps (including office):', this.inDetailsRegReportbtoff);

//   // Initialize grand totals
//   this.advtamt = 0;
//   this.netadvtamt = 0;
//   this.gstadvtamt = 0;
//   this.totaladvtamt = 0;
//   this.totalgst = 0;
//   this.remaingtotal = 0;
//   this.totalpendingadvtamt = 0;
//   this.jamatotal = 0;
//   this.totalbeforegst_amt = 0;
//   this.totaldisc_total = 0;

//   // Calculate totals for ALL off-representatives (including office)
//   for (let offRepData of this.inDetailsRegReportbtoff) {
//     // Initialize off-rep totals
//     offRepData.total_advt_amt = 0;
//     offRepData.total_net_amt = 0;
//     offRepData.total_before_gst_amt = 0;
//     offRepData.total_gst_amt = 0;
//     offRepData.total_amount = 0;
//     offRepData.total_receive_amt = 0;
//     offRepData.total_pending_amt = 0;

//     // Calculate totals for each representative under this off-rep
//     if (offRepData.rep_data && offRepData.rep_data.length > 0) {
//       for (let repData of offRepData.rep_data) {
//         // **MAP udishta_column to udhistha for each rep**
//         repData.udhistha = repData.udishta_column || 0;
        
//         offRepData.total_advt_amt += parseFloat(repData.total_advt_amount) || 0;
//         offRepData.total_net_amt += parseFloat(repData.total_discounted_amt) || 0;
//         offRepData.total_before_gst_amt += parseFloat(repData.total_before_gst) || 0;
//         offRepData.total_gst_amt += parseFloat(repData.total_gst) || 0;
//         offRepData.total_amount += parseFloat(repData.total_amt) || 0;
//         offRepData.total_receive_amt += parseFloat(repData.pymt_rcv_amt) || 0;
//         offRepData.total_pending_amt += parseFloat(repData.total_pending) || 0;
//       }
//     }

//     // Add off-rep totals to grand totals (ALL reps including office)
//     this.advtamt += offRepData.total_advt_amt;
//     this.totaladvtamt += offRepData.total_net_amt;
//     this.totalbeforegst_amt += offRepData.total_before_gst_amt;
//     this.totalgst += offRepData.total_gst_amt;
//     this.netadvtamt += offRepData.total_amount;
//     this.jamatotal += offRepData.total_receive_amt;
//     this.totalpendingadvtamt += offRepData.total_pending_amt;
//   }

//   console.log('Grand Total (including all reps):', this.netadvtamt);
//   console.log('Total Received:', this.jamatotal);
//   console.log('Total Pending:', this.totalpendingadvtamt);

//   // **IMPORTANT: Store this separately for the first table**
//   this.inDetailsRegReportbtoff101 = JSON.parse(JSON.stringify(this.inDetailsRegReportbtoff));

//   this.calculateTotalUdhistha();
//   this.addFilters();
//   this.getReportDatewise();
  
//   // **CRITICAL: Separate office rep from regular reps**
//   this.separateOfficeRepData(data);
// });

this.service.getRegReportInDetailsoff(req1).subscribe((data) => {
  this.inDetailsRegReport = data;
  this.inDetailsRegReportbtoff = data || [];
  this.inDetailsRegReport1 = data;
  this.issuenamewithdate = this.inDetailsRegReport1.issue_date;

  // ✅ CRITICAL FIX: Load saved values from database into component variables
  if (data && data.length > 0) {
    const firstOffRep = data[0];
    
    // These values come from the Udishta table in your database
    this.magil_varshachi_aajchi_stithi = Number(firstOffRep.magil_varshachi_aajchi_stithi) || 0;
    this.magil_varshyachya_ekun_jahirata = Number(firstOffRep.magil_varshyachya_ekun_jahirata) || 0;
    this.officeAdvt = Number(firstOffRep.Udishta_8) || 0;
    
    console.log('✅ Loaded from DB:');
    console.log('  - magil_varshachi_aajchi_stithi:', this.magil_varshachi_aajchi_stithi);
    console.log('  - magil_varshyachya_ekun_jahirata:', this.magil_varshyachya_ekun_jahirata);
    console.log('  - officeAdvt (Udishta_8):', this.officeAdvt);
  }

  console.log('All Off-Reps (including office):', this.inDetailsRegReportbtoff);

  // Initialize grand totals
  this.advtamt = 0;
  this.netadvtamt = 0;
  this.gstadvtamt = 0;
  this.totaladvtamt = 0;
  this.totalgst = 0;
  this.remaingtotal = 0;
  this.totalpendingadvtamt = 0;
  this.jamatotal = 0;
  this.totalbeforegst_amt = 0;
  this.totaldisc_total = 0;

  // Calculate totals for ALL off-representatives (including office)
  for (let offRepData of this.inDetailsRegReportbtoff) {
    // Initialize off-rep totals
    offRepData.total_advt_amt = 0;
    offRepData.total_net_amt = 0;
    offRepData.total_before_gst_amt = 0;
    offRepData.total_gst_amt = 0;
    offRepData.total_amount = 0;
    offRepData.total_receive_amt = 0;
    offRepData.total_pending_amt = 0;

    // Calculate totals for each representative under this off-rep
    if (offRepData.rep_data && offRepData.rep_data.length > 0) {
      for (let repData of offRepData.rep_data) {
        // MAP udishta_column to udhistha for each rep
        repData.udhistha = repData.udishta_column || 0;
        
        offRepData.total_advt_amt += parseFloat(repData.total_advt_amount) || 0;
        offRepData.total_net_amt += parseFloat(repData.total_discounted_amt) || 0;
        offRepData.total_before_gst_amt += parseFloat(repData.total_before_gst) || 0;
        offRepData.total_gst_amt += parseFloat(repData.total_gst) || 0;
        offRepData.total_amount += parseFloat(repData.total_amt) || 0;
        offRepData.total_receive_amt += parseFloat(repData.pymt_rcv_amt) || 0;
        offRepData.total_pending_amt += parseFloat(repData.total_pending) || 0;
      }
    }

    // Add off-rep totals to grand totals (ALL reps including office)
    this.advtamt += offRepData.total_advt_amt;
    this.totaladvtamt += offRepData.total_net_amt;
    this.totalbeforegst_amt += offRepData.total_before_gst_amt;
    this.totalgst += offRepData.total_gst_amt;
    this.netadvtamt += offRepData.total_amount;
    this.jamatotal += offRepData.total_receive_amt;
    this.totalpendingadvtamt += offRepData.total_pending_amt;
  }

  console.log('Grand Total (including all reps):', this.netadvtamt);
  console.log('Total Received:', this.jamatotal);
  console.log('Total Pending:', this.totalpendingadvtamt);

  // Store this separately for the first table
  this.inDetailsRegReportbtoff101 = JSON.parse(JSON.stringify(this.inDetailsRegReportbtoff));

  this.calculateTotalUdhistha();
  this.addFilters();
  this.getReportDatewise();
  
  // Separate office rep from regular reps
  this.separateOfficeRepData(data);
});


    

    this.service.getRegReportBriefly(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsbriflydata = data;

      this.advtamtb = 0;
      this.netadvtamtb = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotalb = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalb = 0;

      for (let data1 of this.inDetailsbriflydata) {
        this.advtamtb += parseFloat(data1.advt_amt) || 0;
        this.netadvtamtb += parseFloat(data1.total_amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
        this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        this.totalgst += parseFloat(data1.gst)
      }

      console.log(this.inDetailsRegReport, "indeatils");
      this.addFilters();
      this.getReportDatewise();
    });

    this.service.getRegReportOff_rep(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsoff_repdata = data;

      this.advtamtb = 0;
      this.netadvtamtb = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotalb = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalb = 0;

      for (let data1 of this.inDetailsoff_repdata) {
        this.advtamtb += parseFloat(data1.advt_amt) || 0;
        this.netadvtamtb += parseFloat(data1.amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        this.totalgst += parseFloat(data1.gst)

        for (let data2 of data1.advt_data) {
          this.jamatotalb += parseFloat(data2.rcv_amt) || 0;
        }
      }

      console.log(this.inDetailsRegReport, "indeatils");
      this.addFilters();
      this.getReportDatewise();
    });

    this.service.getRegReportOff_repb(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsoff_repdatab = data;

      this.advtamtb = 0;
      this.netadvtamtb = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotalb = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalb = 0;

      for (let data1 of this.inDetailsbriflydata) {
        this.advtamtb += parseFloat(data1.advt_amt) || 0;
        this.netadvtamtb += parseFloat(data1.amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
        this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        this.totalgst += parseFloat(data1.gst)
      }

      console.log(this.inDetailsRegReport, "indeatils");
      this.addFilters();
      this.getReportDatewise();
    });

    this.service.getRegReportInDetailsrep(req1).subscribe((data) => {
      this.inDetailsRegReport = data;

      this.inDetailsRegReportrep = data;
      this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
      // console.log(this.inDetailsRegReport1,  "reg report")

      this.advtamt = 0;
      this.netadvtamt = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotal = 0;
      this.totaldisc_total = 0;
      this.totalbefore_gst = 0;
      this.total_pending = 0
      for (let data2 of this.inDetailsRegReportrep) {
        for (let data1 of data2.advt_data) {
          this.advtamt += parseFloat(data1.advt_amt) || 0;
          this.netadvtamt += parseFloat(data1.total_amount) || 0;
          this.totaladvtamt += parseFloat(data1.amount) || 0;
          // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
          this.remaingtotal += parseFloat(data1.remaingamt) || 0;
          this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
          this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
          this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;
          this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
          data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
          this.totalgst += parseFloat(data1.totalgst) || 0;
          this.total_pending += parseFloat(data1.remaining_amt)
        }

      }

      console.log(this.total_pending, "total_pending");
      this.addFilters();
      this.getReportDatewise();

      // this.getReportDatewise();
    });

    this.service.getRegReportInDetailsdatewise(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsRegReportdatewise = data;
      this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
      // console.log(this.inDetailsRegReport1,  "reg report")

      this.advtamt = 0;
      this.netadvtamt = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotal = 0;
      this.totaldisc_total = 0;
      this.totalbefore_gst = 0;
      this.total_pending = 0
      for (let data2 of this.inDetailsRegReportrep) {
        for (let data1 of data2.advt_data) {
          this.advtamt += parseFloat(data1.advt_amt) || 0;
          this.netadvtamt += parseFloat(data1.total_amount) || 0;
          this.totaladvtamt += parseFloat(data1.amount) || 0;
          // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
          this.remaingtotal += parseFloat(data1.remaingamt) || 0;
          this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
          this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
          this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;
          this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
          data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
          this.totalgst += parseFloat(data1.totalgst) || 0;
          this.total_pending += parseFloat(data1.remaining_amt)
        }

      }

      console.log(this.inDetailsRegReportdatewise, "inDetailsRegReportdatewise");
      this.addFilters();
      this.getReportDatewise();

      // this.getReportDatewise();
    });
  }

  getReportDatewise() {

    if (this.filteredinDetailsRegReport.length > 0) {
      this.tempdata = this.uniqueId(
        this.filteredinDetailsRegReport,
        (a) => a.booking_date
      );
      // console.log('why', tempData);
      for (let index = 0; index < this.tempdata.length; index++) {
        let arr = this.filteredinDetailsRegReport.filter((a) => {
          return a.booking_date == this.tempdata[index]['booking_date'];
        });

        let inDetailsRegReportsubTotal = {
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        debugger
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseFloat(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseFloat(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(arr);
        console.log(this.inDetailsRegReportsubTotalData, "abc")
      }
    }
  }

  inDetails() {
    console.log('inDetails');
    this.getReportData();
  }

  inDetailsDatewise() {
    console.log('inDetailsDatewise');
    this.getReportData();
    // setTimeout(() => {
    this.getReportDatewise();
    // }, 200);
  }

  offrepVeryBriefly() {
    console.log('offrepVeryBriefly');
    this.getReportData();
    setTimeout(() => {
      this.getReportOffRepVeryBriefly();
    }, 200);
  }

  datewiseVeryBriefly() {
    this.getReportData();
    setTimeout(() => {
      this.getReportDatewiseVeryBriefly();
    }, 200);
  }

  inDetailsOffRep() {
    this.getReportData();
    setTimeout(() => {
      this.getReportInDetailOffRep();
    }, 200);
  }

  uniqueId(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  toInt(no) {
    return parseFloat(no);
  }

  getReportDatewiseVeryBriefly() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.uniqueId(
        this.inDetailsRegReport,
        (a) => a.booking_date
      );
      // console.log('why', tempData);
      for (let index = 0; index < this.tempdata.length; index++) {
        let arr = this.inDetailsRegReport.filter((a) => {
          return a.booking_date == this.tempdata[index]['booking_date'];
        });

        let inDetailsRegReportsubTotal = {
          date: '',
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        inDetailsRegReportsubTotal.date = arr[0]['booking_date'];
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseFloat(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseFloat(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
      }
      // console.log(this.inDetailsRegReportsubTotalData);
    }
  }

  repData = [];
  getReportInDetailOffRep() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a.off_rep_name);
      });
      this.calculateTotal(this.tempdata);

      let data = this.uniqueId(this.tempdata, (a) => a.rep_name);

      for (let index = 0; index < Object.keys(data).length; index++) {
        let arr = this.tempdata.filter((a) => {
          return a.rep_name == data[index]['rep_name'];
        });

        let inDetailsRegReportsubTotal = {
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseFloat(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseFloat(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(arr);
      }
    }
  }

  calculateTotal(data) {
    this.inDetailsOffRegReportTotal.total_advt = data.length;
    for (let index = 0; index < data.length; index++) {
      this.inDetailsOffRegReportTotal.net_amt += parseFloat(
        data[index]['total_amount']
      );
      this.inDetailsOffRegReportTotal.advt_total += parseFloat(
        data[index]['advt_amt']
      );
      this.inDetailsOffRegReportTotal.gst += parseFloat(data[index]['sgst']);
      this.inDetailsOffRegReportTotal.gst += parseFloat(data[index]['cgst']);
      this.inDetailsOffRegReportTotal.total_amt += parseFloat(
        data[index]['amount']
      );
      this.inDetailsOffRegReportTotal.rcvd_amt += parseFloat(
        data[index]['part_pymt_amt']
      );
      this.inDetailsOffRegReportTotal.pndg_amt += parseFloat(
        data[index]['part_pymt_remaning_amt']
      );
    }
  }

  getReportOffRepVeryBriefly() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a.off_rep_name);
      });
      this.calculateTotal(this.tempdata);

      let data = this.uniqueId(this.tempdata, (a) => a.rep_name);

      for (let index = 0; index < Object.keys(data).length; index++) {
        let arr = this.tempdata.filter((a) => {
          return a.rep_name == data[index]['rep_name'];
        });

        let inDetailsRegReportsubTotal = {
          off_rep_name: '',
          rep_name: '',
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.off_rep_name = arr[index]['off_rep_name'];
          inDetailsRegReportsubTotal.rep_name = arr[index]['rep_name'];
          inDetailsRegReportsubTotal.net_amt += parseFloat(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseFloat(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        // arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
      }
    }
  }







  // Helper method to update input values in cloned content
  private updateInputValuesInClonedContent(clonedElement: HTMLElement): void {
    // Get all input elements in the cloned content
    const clonedInputs = clonedElement.querySelectorAll('input[type="number"]');

    clonedInputs.forEach((clonedInput: HTMLInputElement, index: number) => {
      // Find corresponding input in original DOM to get current value
      let originalInput: HTMLInputElement | null = null;

      // Try to find by ngModel binding or other attributes
      if (clonedInput.hasAttribute('ng-reflect-model')) {
        const modelValue = clonedInput.getAttribute('ng-reflect-model');
        originalInput = document.querySelector(`input[ng-reflect-model="${modelValue}"]`) as HTMLInputElement;
      } else {
        // Fallback: find by position/context
        const allOriginalInputs = document.querySelectorAll('input[type="number"]');
        originalInput = allOriginalInputs[index] as HTMLInputElement;
      }

      if (originalInput && originalInput.value) {
        // Replace input with a span containing the value
        const valueSpan = document.createElement('span');
        valueSpan.className = 'print-input-value';
        valueSpan.textContent = originalInput.value;

        // Copy styles from parent cell
        const parentCell = clonedInput.closest('td');
        if (parentCell) {
          const cellStyle = window.getComputedStyle(parentCell);
          if (cellStyle.textAlign) {
            valueSpan.style.textAlign = cellStyle.textAlign;
          }
        }

        // Replace the input with the value span
        clonedInput.parentNode?.replaceChild(valueSpan, clonedInput);
      } else if (originalInput && !originalInput.value) {
        // If no value, replace with empty span
        const emptySpan = document.createElement('span');
        emptySpan.className = 'print-input-value';
        emptySpan.textContent = '';
        clonedInput.parentNode?.replaceChild(emptySpan, clonedInput);
      }
    });

    // Also handle computed values and percentages
    this.updateComputedValuesInClonedContent(clonedElement);
  }

  // Helper method to update computed values (percentages, totals, etc.)
  private updateComputedValuesInClonedContent(clonedElement: HTMLElement): void {
    // Update totalUdhistha display
    const totalUdhisthaElements = clonedElement.querySelectorAll('*');
    totalUdhisthaElements.forEach(element => {
      if (element.textContent?.includes('{{ totalUdhistha }}')) {
        element.textContent = element.textContent.replace('{{ totalUdhistha }}', this.totalUdhistha?.toString() || '0');
      }
    });

    // Update percentage displays
    const percentageElements = clonedElement.querySelectorAll('*');
    percentageElements.forEach(element => {
      const textContent = element.textContent;
      if (textContent?.includes('%')) {
        // Handle dynamic percentage calculations
        if (textContent.includes('totalUdhisthaPercent')) {
          element.textContent = textContent.replace(/.*totalUdhisthaPercent.*/, `${this.totalUdhisthaPercent?.toFixed(2) || '0.00'}%`);
        }
      }
    });

    // Update other computed values like office values, total business, etc.
    this.updateOtherComputedValues(clonedElement);
  }

  // Helper method to update other computed values
  private updateOtherComputedValues(clonedElement: HTMLElement): void {
    // Update office advertisement value
    if (this.officeAdvt) {
      const officeAdvtElements = clonedElement.querySelectorAll('input[ng-reflect-model*="officeAdvt"]');
      officeAdvtElements.forEach(element => {
        const span = document.createElement('span');
        span.className = 'print-input-value';
        span.textContent = this.officeAdvt.toString();
        element.parentNode?.replaceChild(span, element);
      });
    }

    // Update office total amount
    if (this.officeTotalAmt) {
      const officeTotalElements = clonedElement.querySelectorAll('input[ng-reflect-model*="officeTotalAmt"]');
      officeTotalElements.forEach(element => {
        const span = document.createElement('span');
        span.className = 'print-input-value';
        span.textContent = this.officeTotalAmt.toString();
        element.parentNode?.replaceChild(span, element);
      });
    }

    // Update last year today value
    if (this.lastYearToday) {
      const lastYearElements = clonedElement.querySelectorAll('input[ng-reflect-model*="lastYearToday"]');
      lastYearElements.forEach(element => {
        const span = document.createElement('span');
        span.className = 'print-input-value';
        span.textContent = this.lastYearToday.toString();
        element.parentNode?.replaceChild(span, element);
      });
    }

    // Update last year total advertisement
    if (this.lastYearTotalAdvt) {
      const lastYearTotalElements = clonedElement.querySelectorAll('input[ng-reflect-model*="lastYearTotalAdvt"]');
      lastYearTotalElements.forEach(element => {
        const span = document.createElement('span');
        span.className = 'print-input-value';
        span.textContent = this.lastYearTotalAdvt.toString();
        element.parentNode?.replaceChild(span, element);
      });
    }
  }

  onUdhisthaChange(index: number, value: any) {
    this.inDetailsRegReportbtoff[index].udhistha = Number(value) || 0;

    this.gsiValues = this.inDetailsRegReportbtoff
      .slice(0, 7) // first 7 items
      .map(item => Number(item.udhistha) || 0);
    this.calculateTotalUdhistha();
  }

  // saveAll() {
  //   this.service.saveAllRows(this.gsiValues)
  //     .subscribe({
  //       next: res => console.log('Saved successfully', res),
  //       error: err => console.error('Error saving', err)
  //     });
  // }


  //   saveAll() {
  //   // Prepare object with keys that PHP expects
  //   const payload: any = {
  //     issue_name: this.newissuedatepp,     // bind from your form
  //     issue_date: this.issuedatepp,     // bind from your form
  //   };

  //   // Map gsiValues into Udhishta_1 .. Udhishta_7
  //   this.gsiValues.slice(0, 7).forEach((val, idx) => {
  //     payload[`Udishta_${idx + 1}`] = val;
  //   });

  //   this.service.saveAllRows(payload)
  //     .subscribe({
  //       next: (res: any) => {
  //         if(res.status === 'success'){
  //           alert('Saved successfully! ' );
  //         } else {
  //           alert('Error: ');
  //         }
  //       },
  //       error: (err: any) => {
  //         alert('Error saving data. Please try again.');
  //         console.error('Error saving', err);
  //       }
  //     });
  // }


  


  magil_varshachi_aajchi_stithi: number = 0;
  magil_varshyachya_ekun_jahirata: number = 0;
  Udishta_8: number = 0;
  magilVarshiAjchiSthiti: number = 0;
  magilVarshEkunJahirat: number = 0;

  // saveAll() {

  //   // Prepare object with keys that PHP expects
  //   const payload: any = {
  //     issue_name: this.newissuedatepp,  // existing
  //     issue_date: this.issuedatepp,     // existing
  //   };

  //   // Map gsiValues into Udhishta_1 .. Udhishta_7
  //   this.gsiValues.slice(0, 7).forEach((val, idx) => {
  //     payload[`Udishta_${idx + 1}`] = val;
  //   });

  //   // ✅ Add footer input field data
  //   payload.office_advt = this.officeAdvt;                      // कार्यालय - जाहिरात विभाग
  //   payload.magil_varshi_ajchi_sthiti = this.magil_varshachi_aajchi_stithi; // मागील वर्षीची आजची स्थिती
  //   payload.magil_varsh_ekun_jahirat = this.magil_varshyachya_ekun_jahirata;   // मागील वर्षीच्या एकूण जाहिरात

  //   console.log("Payload to save:", payload);

  //   // Send to backend
  //   this.service.saveAllRows(payload).subscribe({
  //     next: (res: any) => {
  //       if (res.status === 'success') {
  //         alert('Saved successfully!');
  //       } else {
  //         alert('Error saving data.');
  //       }
  //     },
  //     error: (err: any) => {
  //       alert('Error saving data. Please try again.');
  //       console.error('Error saving', err);
  //     }
  //   });

  //   this.saveAllUdhistha(); 
  // }



//  saveAllUdhistha() {
//   const payloadData = [];

//   this.inDetailsRegReportbtoff101.forEach(group => {
//     group.rep_data.forEach(rep => {
//       payloadData.push({
//         rep_name: rep.rep_name,
//         udhistha: rep.udhistha || 0,
//         status: rep.status ? 1 : 0
//       });
//     });
//   });

//   this.service.saveAllUdhistha(
//     this.newissuedatepp,   // issue_name
//     this.issuedatepp,      // issue_date
//     payloadData            // data[]
//   ).subscribe(() => {
//     this.inDetailsRegReportbtoff101.forEach(g =>
//       g.rep_data.forEach(r => r.status = 1)
//     );
//     alert('Rep-wise Udhistha Saved!');
//   });
// }

// saveAllUdhistha() {
//   const payloadData = [];

//   this.inDetailsRegReportbtoff101.forEach(group => {
//     group.rep_data.forEach(rep => {
//       payloadData.push({
//        rep_name: rep.rep_name,
//   udhistha: rep.udhistha,
//   status: rep.status ? 1 : 0
//       });
//     });
//   });

//   this.service.saveAllUdhistha(
//     this.newissuedatepp,   // issue_name
//     this.issuedatepp,      // issue_date
//     payloadData            // data[]
//   ).subscribe(() => {
//     this.inDetailsRegReportbtoff101.forEach(g =>
//       g.rep_data.forEach(r => r.status = 1)
//     );
//     alert('Rep-wise Udhistha Saved!');
//   });
// }



saveAll() {
  const payload: any = {
    issue_name: this.newissuedatepp,
    issue_date: this.issuedatepp,
  };

  console.log("Values before payload creation:");
console.log("magil_varshachi_aajchi_stithi:", this.magil_varshachi_aajchi_stithi);
console.log("magil_varshyachya_ekun_jahirata:", this.magil_varshyachya_ekun_jahirata);
console.log("officeAdvt:", this.officeAdvt);

  this.gsiValues.slice(0, 7).forEach((val, idx) => {
    payload[`Udishta_${idx + 1}`] = val;
  });

  // ✅ Use the same property names as your component variables
  payload.office_advt = this.officeAdvt;
   payload.magil_varshi_ajchi_sthiti = this.magil_varshachi_aajchi_stithi;  // Changed key name
  payload.magil_varsh_ekun_jahirat = this.magil_varshyachya_ekun_jahirata;  // Changed key n

  console.log("Payload to save:", payload);

  this.service.saveAllRows(payload).subscribe({
    next: (res: any) => {
      if (res.status === 'success') {
        alert('Saved successfully!');
      } else {
        alert('Error saving data.');
      }
    },
    error: (err: any) => {
      alert('Error saving data. Please try again.');
      console.error('Error saving', err);
    }
  });

  this.saveAllUdhistha();
}

saveAllUdhistha() {
  console.log('inDetailsRegReportbtoff101:', this.inDetailsRegReportbtoff101);
  
  const payloadData = [];

  this.inDetailsRegReportbtoff101.forEach(offRep => {
    offRep.rep_data.forEach(rep => {
      payloadData.push({
        rep_name: rep.rep_name,
        udhistha: Number(rep.udhistha || rep.udishta_column || 0),  // Use either field
        status: rep.status ? 1 : 0
      });
    });
  });

  console.log('Final Payload:', payloadData);

  if (payloadData.length === 0) {
    alert('No udhistha values to save!');
    return;
  }

  this.service.saveAllUdhistha(
    this.newissuedatepp,
    this.issuedatepp,
    payloadData
  ).subscribe(
    (response) => {
      console.log('Save response:', response);
      this.inDetailsRegReportbtoff101.forEach(offRep =>
        offRep.rep_data.forEach(rep => rep.status = 1)
      );
      alert('Rep-wise Udhistha Saved Successfully!');
    },
    (error) => {
      console.error('Save error:', error);
      alert('Error: ' + (error.error?.message || error.message));
    }
  );
}



  calculateTotalUdhistha() {
    this.totalUdhistha = (this.inDetailsRegReportbtoff || []).reduce(
      (sum, item) => sum + (Number(item.udhistha) || 0),
      0
    );
  }

  // optional convenience getter for percent of netadvtamt
  get totalUdhisthaPercent(): number {
    if (!this.totalUdhistha || this.totalUdhistha === 0) {
      return 0; // show 0% when denominator is missing/zero
    }
    return (this.netadvtamt / this.totalUdhistha) * 100;
  }





  printPageA4Portrait() {
    const printContents = document.getElementById('print-section')?.innerHTML || '';
    let secondPageContents = document.querySelector('.second-page-table')?.outerHTML || '';

    // Capture all input values from the second page table
    const inputs = document.querySelectorAll('.second-page-table input');
    const inputValues = {};
    inputs.forEach((input, index) => {
      inputValues[index] = (input as HTMLInputElement).value;
    });

    // Replace input elements with their values in the HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = secondPageContents;

    const tempInputs = tempDiv.querySelectorAll('input');
    tempInputs.forEach((input, index) => {
      const value = inputValues[index] || '';
      const span = document.createElement('span');
      span.textContent = value;
      span.style.fontWeight = 'bold';
      span.style.textAlign = 'right';
      span.style.display = 'inline-block';
      span.style.width = '100%';
      input.parentNode.replaceChild(span, input);
    });

    secondPageContents = tempDiv.innerHTML;

    const originalContents = document.body.innerHTML;

    const printWindow = window.open('', '_blank', 'width=794,height=1123');

    if (printWindow) {
      printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Print Report</title>
        <style>
          @page {
            size: A4 portrait;
            margin: 10mm 8mm 10mm 8mm;
          }
          
          @media print {
            body {
              font-family: Arial, sans-serif;
              font-size: 13px;
              line-height: 1.2;
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            table {
              border-collapse: collapse;
              width: 100%;
              page-break-inside: avoid;
            }
            
            th, td {
              border: 1px solid #000 !important;
              padding: 4px 6px !important;
              font-size: 13px !important;
              vertical-align: middle;
            }
            
            .table-bordered th,
            .table-bordered td {
              border: 1px solid #000 !important;
            }
            
            /* Ensure yellow background prints */
            .yellow,
            [style*="background-color: yellow"],
            [style*="background-color:#e7e709"] {
              background-color: #ffff00 !important;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            /* Ensure other background colors print */
            [style*="background-color: #8ed9dd"] {
              background-color: #8ed9dd !important;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            [style*="background-color: #f8f9fa"] {
              background-color: #f8f9fa !important;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            /* Hide print buttons and non-printable elements */
            .noPrint,
            button,
            .btn {
              display: none !important;
            }
            
            /* Page break handling */
            .second-page-table {
              page-break-before: always;
              margin-top: 0;
            }
            
            /* Adjust font sizes for better fit */
            th {
              font-weight: bold !important;
              text-align: center;
            }
            
            /* Ensure proper text alignment */
            [style*="text-align: center"] {
              text-align: center !important;
            }
            
            [style*="text-align: end"],
            [style*="text-align: right"] {
              text-align: right !important;
            }
            
            [style*="text-align: left"] {
              text-align: left !important;
            }
            
            /* Input fields in print - now handled by spans */
            input {
              border: none !important;
              background: transparent !important;
              font-weight: bold !important;
              text-align: right !important;
              width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            
            /* Ensure proper spacing */
            div {
              margin: 0;
              padding: 0;
            }
            
            /* First table styling */
            #print-section {
              margin: 0;
              padding: 0;
              display: block;
            }
            
            #print-section table {
              width: 100%;
              margin: 0 auto;
            }
            
            /* Second table styling */
            .second-page-table table {
              width: 100%;
              width: 60%;
              margin: 20px auto;
            }

            .second-page-table .second-page-header {
  font-size: 24px !important;
  font-weight: bold !important;
  text-align: center !important;
  padding: 8px !important;
}


          }
          
          /* Screen styles for preview */
          @media screen {
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            
            table {
              border-collapse: collapse;
              margin: 20px auto;
            }
            
            th, td {
              border: 1px solid #000;
              padding: 8px;
          th {
              border: 1px solid #000;
              padding: 8px;
              font-size : 20px;
          }
 

            td {
              border: 1px solid #000;
              padding: 8px;
              font-size : 12px;
            }
            
            .yellow {
              background-color: #ffff00;
            }
          }
        </style>
      </head>
      <body>
        <div id="print-section">
          ${printContents}
        </div>
        ${secondPageContents}
      </body>
      </html>
    `);

      printWindow.document.close();

      // Wait for content to load before printing
      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 500);
      };
    }
  }



}









